import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { EditIcon, PlusIcon, LockIcon } from '../components/shared/Icons';
import ChangePassword from './ChangePassword';
import DepartureTicketForm from './DepartureTicketForm';
import NewDeparture from './NewDeparture';
import DepartureUpload from './DepartureUpload';
import FilterClientTickets from './FilterClientTickets';
import CalendarIframe from './CalendarIframe';
import FilterDeparture from './FilterDeparture';

const TABS = [
  { id: 'workflowclientim', label: 'Add' },
  { id: 'accountsclientim', label: 'Update' },
];

const CLIENTWORK_INNER = [
  { id: 'newformm', label: 'New', icon: <PlusIcon />, component: NewDeparture },
  { id: 'departureuploadm', label: 'Upload', icon: <PlusIcon />, component: DepartureUpload },
  { id: 'clientticketm', label: 'Ticket', icon: <PlusIcon />, component: DepartureTicketForm },
];

const PERSONAL_INNER = [
  { id: 'updatedepartesm', label: 'Departure', icon: <EditIcon />, component: FilterDeparture },
  { id: 'ticketupdatesm', label: 'Ticket', icon: <EditIcon />, component: FilterClientTickets },
  { id: 'passwordm', label: 'Password', icon: <LockIcon />, component: ChangePassword },
];

const DEFAULT_TAB = 'workflowclientim';
const DEFAULT_INNER = { workflowclientim: 'newformm', accountsclientim: 'ticketupdatesm' };

const FilterIgluPersonalPagem = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { homeAccent } = useUser();
  const [activeTab, setActiveTab] = useState(location.state?.tab || DEFAULT_TAB);
  const [innerId, setInnerId] = useState(location.state?.inner || null);
  const [resetKey, setResetKey] = useState(location.state?.reset || 0);

  // FooterNav "New Form" sends { tab, inner, reset } — apply it even when already on this route
  useEffect(() => {
    const st = location.state;
    if (!st?.tab) return;
    setActiveTab(st.tab);
    if (!st.reset) return;         // mirror-only update from the tab bar → nothing else to do
    setInnerId(st.inner || null);
    setResetKey(st.reset);
  }, [location.state]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setInnerId(null);
    // mirror into location state (no history entry) so FooterNav highlights the matching button
    navigate(location.pathname, { replace: true, state: { tab } });
  };

  const innerFor = (tab) => innerId || DEFAULT_INNER[tab];

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'workflowclientim' && (
          <InnerTabsm key={`w-${resetKey}`} tabs={CLIENTWORK_INNER} defaultId={innerFor('workflowclientim')} />
        )}
        {activeTab === 'accountsclientim' && (
          <InnerTabsm key={`a-${resetKey}`} tabs={PERSONAL_INNER} defaultId={innerFor('accountsclientim')} />
        )}
      </div>
    </div>
  );
};

export default FilterIgluPersonalPagem;